export let options = [
    {
        value: "en",
        label: (
            <>
                <img
                    src="/menuicon/flagUK.svg"
                    alt="flagUK"
                    style={{ display: "inline" }}
                />
                <span style={{ paddingLeft: "10px" }}>English</span>
            </>
        ),
    },
    {
        value: "hy",
        label: (
            <>
                <img
                    src="/menuicon/flagARM.svg"
                    alt="flagARM"
                    style={{ display: "inline" }}
                />
                <span style={{ paddingLeft: "10px" }}>Armenian</span>
            </>
        ),
    },
    {
        value: "ru",
        label: (
            <>
                <img
                    src="/menuicon/flagRu.svg"
                    alt="flagRU"
                    style={{ display: "inline", width: "25px", height: "18px" }}
                />
                <span style={{ paddingLeft: "10px" }}>Russian</span>
            </>
        ),
    },
];

export function getCookie(name) {
    let cookie = {};
    document.cookie.split(";").forEach(function (el) {
        let [k, v] = el.split("=");
        cookie[k.trim()] = v;
    });
    return cookie[name];
}
